<template>
  <portal-layout>
    <div class="student-page">
      <div class="page-head">
        <h2 class="page-title">小主档案</h2>
        <el-button v-if="students.length < 10" type="primary" size="small" @click="addStudent">
          <i class="el-icon-plus"></i> 添加小主
        </el-button>
      </div>

      <div v-loading="loading" class="student-card">
        <div v-if="!loading && students.length === 0" class="empty-tip">
          暂无小主信息，点击右上角「添加小主」创建
        </div>

        <div v-else class="student-list">
          <div v-for="(stu, index) in students" :key="index" class="student-item">
            <div class="item-header">
              <div class="item-avatar">
                <i class="el-icon-user-solid"></i>
              </div>
              <span class="item-name">{{ stu.name || '未填写姓名' }}</span>
              <el-tag v-if="stu.id" size="mini" type="success" effect="plain">已保存</el-tag>
              <el-tag v-else size="mini" type="warning" effect="plain">待保存</el-tag>
            </div>

            <el-form label-width="80px" size="small" class="item-form">
              <el-form-item label="姓名">
                <el-input v-model="stu.name" placeholder="请输入小主姓名" maxlength="20"></el-input>
              </el-form-item>
              <el-form-item label="性别">
                <el-radio-group v-model="stu.sex">
                  <el-radio label="1">男生</el-radio>
                  <el-radio label="0">女生</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="生日">
                <el-date-picker v-model="stu.bridge" type="date" placeholder="请选择生日"
                                value-format="yyyy-MM-dd" class="date-picker">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="备注">
                <el-input v-model="stu.remark" type="textarea" :rows="2"
                          placeholder="选填" maxlength="100"></el-input>
              </el-form-item>
            </el-form>

            <div class="item-action">
              <el-button size="small" @click="removeStudent(stu, index)">删除</el-button>
              <el-button type="primary" size="small" @click="saveStudent(stu)">
                {{ stu.id ? '保存修改' : '保存' }}
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </portal-layout>
</template>
<script>
import PortalLayout from '@/components/PortalLayout.vue';
import api from '@/common/api';
import storage from '@/common/storage.js';

export default {
  name: 'PortalStudentArchive',
  components: { PortalLayout },
  data() {
    return {
      loading: false,
      students: []
    }
  },
  created() {
    if (!this.checkLogin()) {
      return;
    }
    this.loadStudents();
  },
  methods: {
    checkLogin() {
      if (!storage.getString('portalMember')) {
        if (this.$route.name === 'PortalLogin') return false;
        this.$router.push({ name: 'PortalLogin', query: { redirect: this.$route.fullPath } }).catch(() => {});
        return false;
      }
      return true;
    },
    loadStudents() {
      this.loading = true;
      api.student_list().then((r) => {
        if (r.data.code === "200") {
          // R.ok(List) 走 rows 字段
          const list = r.data.rows || [];
          // 补齐表单需要的字段，避免 el-radio-group / date-picker 绑定 undefined
          this.students = list.map((it) => ({
            id: it.id,
            name: it.name || '',
            sex: it.sex || '',
            bridge: it.bridge || '',
            remark: it.remark || ''
          }));
        }
      }).catch(() => {
        // 401 已由 common/api.js 统一跳转登录页
      }).finally(() => {
        this.loading = false;
      });
    },
    addStudent() {
      this.students.push({ id: null, name: '', sex: '', bridge: '', remark: '' });
    },
    saveStudent(stu) {
      if (!stu.name) {
        this.$message.warning('请输入小主姓名');
        return;
      }
      const payload = {
        name: stu.name,
        sex: stu.sex,
        bridge: stu.bridge,
        remark: stu.remark
      };
      if (stu.id) {
        payload.id = stu.id;
        api.student_edit(payload).then((r) => {
          if (r.data.code === "200") {
            this.$message.success('修改成功');
            this.loadStudents();
          }
        }).catch(() => {});
      } else {
        api.student_add(payload).then((r) => {
          if (r.data.code === "200") {
            this.$message.success('添加成功');
            this.loadStudents();
          }
        }).catch(() => {});
      }
    },
    removeStudent(stu, index) {
      // 未保存的新增行，直接从列表移除，无需调接口
      if (!stu.id) {
        this.students.splice(index, 1);
        return;
      }
      this.$confirm('确定删除该小主档案吗？', '提示', {
        type: 'warning',
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        api.student_delete({ id: stu.id }).then((r) => {
          if (r.data.code === "200") {
            this.$message.success('删除成功');
            this.loadStudents();
          }
        }).catch(() => {});
      }).catch(() => {});
    }
  }
};
</script>
<style scoped>
.page-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.page-title {
  font-size: 22px;
  color: #303133;
  margin: 0;
}
.student-card {
  background-color: #fff;
  border-radius: 8px;
  padding: 25px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  min-height: 200px;
}
.student-list {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}
.student-item {
  width: calc((100% - 20px) / 2);
  border: 1px solid #ebeef5;
  border-radius: 8px;
  padding: 20px;
}
.item-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #ebeef5;
}
.item-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: #ecf5ff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.item-avatar i {
  font-size: 18px;
  color: #409EFF;
}
.item-name {
  flex: 1;
  font-size: 15px;
  color: #303133;
  font-weight: 500;
}
.item-form {
  margin-bottom: 5px;
}
.date-picker {
  width: 100%;
}
.item-action {
  text-align: right;
  padding-top: 10px;
  border-top: 1px solid #ebeef5;
}
.empty-tip {
  text-align: center;
  color: #909399;
  padding: 60px 0;
  font-size: 14px;
}
@media (max-width: 1000px) {
  .student-item {
    width: 100%;
  }
}
</style>
